import React from 'react';

import {
  useLoadApplication,
  useUpdateApplication,
} from 'scenes/Applications/data';

import ApplicationForm from './ApplicationForm';
import { DAYS, IMPRESSION, CLICK, RECURRING } from './constants';

export const ApplicationFormEdit = ({
  id,
  onClose,
  onExited,
  open,
  ...props
}) => {
  const [updateApplication, { isLoading: isUpdating }] = useUpdateApplication();
  const { data, isLoading } = useLoadApplication(id);

  const handleSubmit = async (values) => {
    await updateApplication(values);
    onClose();
  };

  return (
    <ApplicationForm
      title={`Edit Application`}
      subTitle={data?.name}
      entityId={id}
      initialValues={{
        [DAYS]: 0,
        [IMPRESSION]: 0,
        [CLICK]: 0,
        [RECURRING]: 0,
        ...data,
      }}
      loading={isLoading || isUpdating}
      onClose={onClose}
      enableReinitialize={true}
      editMode={true}
      onExited={onExited}
      open={open}
      {...props}
      onSubmit={handleSubmit}
    />
  );
};
